import { useMemo, useState } from 'react';
import React from 'react';
import { UseChipProps } from '../types/chip-types';

export const useChip = ({
  selected = false,
  disabled = false,
  variant = 'default',
  style = {}
}: UseChipProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const chipStyle: React.CSSProperties = useMemo(() => {
    let baseStyle: React.CSSProperties = {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '8px 16px',
      borderRadius: '9999px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: disabled ? 'not-allowed' : 'pointer',
      transition: 'all 0.2s ease',
      border: '1px solid transparent',
      userSelect: 'none',
      ...style
    };

    if (variant === 'dashed') {
      return {
        ...baseStyle,
        border: '1px dashed #d1d5db',
        backgroundColor: 'transparent',
        color: '#4b5563', // gray-600
      };
    }

    if (selected) {
      return {
        ...baseStyle,
        borderColor: '#4f46e5', // indigo-600
        backgroundColor: '#e0e7ff', // indigo-100
        color: '#4f46e5',
      };
    }

    // Default unselected state
    return {
      ...baseStyle,
      borderColor: '#e5e7eb', // gray-200
      backgroundColor: 'white',
      color: '#374151', // gray-700
      ...(isHovered && !disabled ? { borderColor: '#d1d5db' } : {})
    };
  }, [selected, disabled, variant, style, isHovered]);

  const handleMouseEnter = () => {
    if (!disabled) setIsHovered(true);
  };

  const handleMouseLeave = () => {
    if (!disabled) setIsHovered(false);
  };

  return {
    chipStyle,
    handleMouseEnter,
    handleMouseLeave
  };
};

